import React from "react";
import cn from "classnames";

/**
 * Иконка лупы — SVG-компонент с поддержкой тем
 * @param {string} className - Дополнительные классы
 * @param {string} strokeColor - Цвет обводки (ручка и контур кружка)
 * @param {string} fillColor - Цвет заливки кружка лупы
 * @param {number} width - Ширина
 * @param {number} height - Высота
 */
const SearchIcon = ({
  className,
  strokeColor = "#A1A3B2",
  fillColor = "white",
  width = 18,
  height = 17,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("search_icon", className)}
    >
      <line
        x1="0.75"
        y1="-0.75"
        x2="10.6652"
        y2="-0.75"
        transform="matrix(0.713336 0.700822 -0.713336 0.700822 8.14258 9.00012)"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <ellipse
        cx="6.61607"
        cy="6.50012"
        rx="6.61607"
        ry="6.5"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth="1"
      />
    </svg>
  );
};

export default SearchIcon;
